import React from "react";

const NoRowsSvg = () => {
  return (
    <svg
      width="183"
      height="237"
      viewBox="0 0 183 237"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="17.0088"
        y="101.664"
        width="6.22433"
        height="102.183"
        rx="3.11216"
        fill="#FFBB56"
      />
      <rect
        x="120.229"
        y="80.3975"
        width="6.22433"
        height="120.856"
        rx="3.11216"
        fill="#FFBB56"
      />
      <path
        d="M14.415 113.695C14.415 110.377 16.7452 107.514 19.9947 106.841L121.663 85.7732C126.008 84.8728 130.084 88.1904 130.084 92.6276V139.427C130.084 142.746 127.754 145.608 124.504 146.282L22.8354 167.349C18.4906 168.25 14.415 164.932 14.415 160.495V113.695Z"
        fill="black"
      />
      <rect
        x="167.43"
        y="204.365"
        width="7.78041"
        height="120.856"
        rx="3.89021"
        transform="rotate(90 167.43 204.365)"
        fill="#FFBB56"
      />
      <rect
        x="181.953"
        y="154.052"
        width="7.78041"
        height="120.856"
        rx="3.89021"
        transform="rotate(90 181.953 154.052)"
        fill="#FFBB56"
      />
      <path
        d="M1.85228 170.379C7.50986 121.894 59.9 105.753 84.6696 105.132C162.242 99.0707 162.054 160.039 162.242 204.365L0.983982 204.365C0.984817 191.938 0.599439 181.116 1.85228 170.379Z"
        fill="#6C65D9"
      />
      <path
        d="M49.167 123.451C32.7754 100.263 54.5496 88.3733 68.8423 84.9068C69.7068 84.6971 70.5485 85.2851 70.6858 86.164L71.6483 92.3241C71.7014 92.6636 71.6405 93.0112 71.4753 93.3125L63.5927 107.687C63.2069 108.39 63.4262 109.274 64.0808 109.738C97.0587 133.104 102.206 178.706 102.088 202.589C102.084 203.44 101.391 204.108 100.54 204.108H68.9819C68.0827 204.108 67.3713 203.352 67.4167 202.454C68.3839 183.343 65.69 146.825 49.167 123.451Z"
        fill="#A09AFB"
      />
      <path
        d="M123.599 113.336C128.064 98.4977 115.905 92.3291 107.779 90.5137L44.4986 109.446C38.4818 110.898 36.9775 117.14 36.9775 120.079C43.2019 117.589 52.1926 121.117 55.9099 123.191C86.2535 140.127 114.782 142.642 123.599 113.336Z"
        fill="#A09AFB"
      />
      <path
        d="M119.411 156.022C120.221 147.203 111.143 124.322 105.685 112.161C105.368 111.454 105.907 110.665 106.682 110.697L123.565 111.414C123.947 111.43 124.289 111.655 124.455 112L146.245 157.14C146.451 157.568 146.343 158.087 145.957 158.364C139.405 163.069 130.98 157.813 120.54 157.373C119.858 157.345 119.349 156.702 119.411 156.022Z"
        fill="#A09AFB"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M117.32 122.782C117.833 123.038 118.041 123.661 117.784 124.173C115.322 129.098 111.492 132.349 106.169 135.011C105.656 135.267 105.033 135.06 104.777 134.547C104.521 134.035 104.728 133.412 105.241 133.155C110.291 130.63 113.723 127.657 115.929 123.246C116.185 122.733 116.808 122.525 117.32 122.782Z"
        fill="#252A38"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M73.216 120.52C73.5454 120.051 74.1925 119.938 74.6613 120.268C84.5238 127.198 89.8019 138.085 93.4453 147.453C93.653 147.987 93.3884 148.588 92.8544 148.796C92.3205 149.004 91.7193 148.739 91.5116 148.205C87.8933 138.901 82.7975 128.521 73.4684 121.965C72.9996 121.636 72.8866 120.989 73.216 120.52Z"
        fill="#252A38"
      />
      <path
        d="M57.2391 94.9422C67.1669 88.9855 81.645 89.151 87.6431 89.9783C100.88 91.6329 124.624 97.9206 113.704 109.834C102.783 121.748 81.4383 117.28 72.1309 113.557C63.0304 109.834 47.3113 100.899 57.2391 94.9422Z"
        fill="#252A38"
      />
      <path
        d="M69.0287 112.317L68.4082 79.4307L103.156 90.5995L105.017 115.419C95.0892 120.383 76.4746 116.039 69.0287 112.317Z"
        fill="#E5986D"
      />
      <path
        d="M104.397 104.87C92.4836 106.856 80.4047 97.0106 75.8545 91.8398L103.776 95.5628L104.397 104.87Z"
        fill="#252A38"
      />
      <path
        d="M115.148 57.4959C118.272 77.4715 115.379 95.2216 101.293 97.4249C77.0941 101.21 67.2613 85.4503 64.1369 65.4747C61.0124 45.4991 69.8987 27.5195 83.985 25.3162C98.0713 23.1129 112.023 37.5202 115.148 57.4959Z"
        fill="#E6986D"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M104.935 47.9181C103.75 48.094 102.688 48.7125 102.101 49.2151C101.581 49.6611 100.798 49.6009 100.352 49.0805C99.9055 48.5601 99.9657 47.7767 100.486 47.3306C101.348 46.5923 102.829 45.7215 104.571 45.4631C106.375 45.1953 108.438 45.5957 110.238 47.3954C110.722 47.88 110.722 48.6657 110.238 49.1504C109.753 49.635 108.967 49.635 108.483 49.1504C107.304 47.9717 106.058 47.7515 104.935 47.9181Z"
        fill="#1B1D28"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M89.1904 54.7289C89.8744 54.6719 90.4844 55.0878 90.5528 55.6579L91.1752 60.8447C91.2436 61.4148 90.7445 61.9231 90.0605 61.9801C89.3764 62.0371 88.7664 61.6212 88.698 61.0511L88.0756 55.8643C88.0072 55.2942 88.5063 54.7859 89.1904 54.7289Z"
        fill="#1B1D28"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M106.825 53.1732C107.509 53.1162 108.119 53.5321 108.188 54.1022L108.81 59.289C108.878 59.8591 108.379 60.3674 107.695 60.4245C107.011 60.4815 106.401 60.0655 106.333 59.4955L105.71 54.3086C105.642 53.7386 106.141 53.2302 106.825 53.1732Z"
        fill="#1B1D28"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M91.0647 50.7177C87.7297 49.8839 85.569 51.7592 84.9524 52.6841C84.5722 53.2543 83.8017 53.4084 83.2314 53.0282C82.6612 52.6481 82.5071 51.8776 82.8873 51.3073C83.9253 49.7502 87.0594 47.158 91.6667 48.3098C92.3316 48.476 92.7358 49.1498 92.5696 49.8147C92.4034 50.4796 91.7296 50.8839 91.0647 50.7177Z"
        fill="#1B1D28"
      />
      <path
        d="M76.2779 61.5487C77.3994 68.7184 76.3611 75.0893 71.3052 75.8801C62.6197 77.2387 59.0905 71.5822 57.969 64.4125C56.8476 57.2428 60.0371 50.7896 65.0929 49.9988C70.1488 49.208 75.1565 54.3791 76.2779 61.5487Z"
        fill="#E6986D"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M62.7644 62.2178C63.4498 62.2178 64.0054 62.7734 64.0054 63.4588C64.0054 64.2916 64.1492 65.5183 64.5371 66.4881C64.9401 67.4957 65.4037 67.8022 65.8669 67.8022C66.5522 67.8022 67.1078 68.3578 67.1078 69.0431C67.1078 69.7285 66.5522 70.2841 65.8669 70.2841C63.848 70.2841 62.7604 68.7292 62.2327 67.4099C61.6899 66.0529 61.5234 64.4873 61.5234 63.4588C61.5234 62.7734 62.079 62.2178 62.7644 62.2178Z"
        fill="#1B1D28"
      />
      <path
        d="M71.4713 54.9834C74.5834 71.0629 78.0067 79.2583 91.7002 78.8433C95.3822 78.7317 98.5602 78.4642 101.296 78.0303L104.408 75.7312L108.558 76.0869C112.379 74.4599 114.469 72.2548 115.608 69.1302C115.806 68.5886 116.612 68.6271 116.644 69.2027C117.15 78.1504 114.555 95.887 102.334 98.2943C89.7475 100.773 74.289 97.5245 68.0995 81.4368C62.9128 72.619 72.2493 74.4344 65.7656 59.911L71.4713 54.9834Z"
        fill="#C9C9C9"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M97.5476 83.0954C96.2018 81.6898 97.2849 79.658 98.9353 79.4834L106.837 78.6477C108.113 78.5127 109.244 79.4703 109.321 80.7514L109.376 81.6763C109.407 82.1928 109.263 82.753 108.879 83.2051C107.908 84.3483 106.3 85.5863 104.265 85.8867C102.156 86.198 99.8205 85.4692 97.5476 83.0954ZM99.3358 81.7047C101.134 83.5074 102.714 83.8402 103.936 83.6598C105.248 83.4663 106.386 82.6463 107.128 81.7889L107.074 80.8862L99.3358 81.7047Z"
        fill="#1B1D28"
      />
      <path
        d="M117.194 79.6013C109.681 82.4589 105.752 78.9158 104.423 76.1484C104.226 75.7378 104.273 75.2513 104.543 74.8846C107.7 70.599 113.779 74.0304 117.59 77.259C118.403 77.9485 118.191 79.2221 117.194 79.6013Z"
        fill="#ECECEC"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M100.838 58.9224C101.46 58.7369 102.115 59.0906 102.3 59.7124C103.102 62.402 104.149 64.4915 105.066 66.3241C105.465 67.1198 105.839 67.8671 106.159 68.5941C106.654 69.7213 107.058 70.9048 106.945 72.0583C106.82 73.3261 105.326 74.8429 104.118 75.6411C103.577 75.9988 102.848 75.85 102.49 75.3087C102.132 74.7673 102.281 74.0385 102.823 73.6808C103.602 73.166 104.568 72.2191 104.606 71.8283C104.656 71.3232 104.484 70.6235 104.007 69.5393C103.759 68.9737 103.433 68.3226 103.067 67.5901C102.124 65.7046 100.912 63.2797 100.048 60.384C99.8629 59.7622 100.217 59.1078 100.838 58.9224Z"
        fill="#1B1D28"
      />
      <path
        d="M64.9872 60.17C54.3691 59.0918 51.9692 47.9411 51.9301 44.2383C42.5842 37.552 49.792 31.8586 54.5641 29.8477C54.5641 26.1961 57.4661 19.9713 74.8423 13.2285C96.5567 4.80224 112.877 8.29518 119.969 18.9339C124.637 25.9367 123.368 28.29 121.291 31.2449C109.325 42.8998 93.0278 39.0515 86.3749 35.6704C80.2548 44.934 70.9697 47.0924 67.0922 47.0136C70.9258 50.6898 75.6053 61.2482 64.9872 60.17Z"
        fill="#ECECEC"
      />
      <path
        d="M87.071 80.0139C97.3936 83.0917 102.842 79.4147 104.742 76.4673C105.051 75.9889 104.981 75.3655 104.584 74.9582C100.229 70.4953 91.9372 74.0967 86.7017 77.5146C85.6836 78.1792 85.9059 79.6665 87.071 80.0139Z"
        fill="#ECECEC"
      />
      <path
        d="M105.186 204.628C99.8238 208.202 92.8733 209.791 92.0789 212.372L73.0146 201.054C98.0365 190.33 101.611 201.649 105.186 204.628Z"
        fill="#E5986D"
      />
      <path
        d="M22.376 235.605C4.50319 232.029 0.928525 212.966 0.928711 202.242L27.7379 203.434L68.2494 197.476C85.4072 196.523 93.867 206.412 94.4627 212.966C95.0585 219.52 40.2487 239.18 22.376 235.605Z"
        fill="#6C65D9"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M86.9515 202.177C87.3181 201.648 88.0443 201.516 88.5738 201.882C89.9515 202.836 91.9794 204.585 93.6752 206.792C95.359 208.984 96.8209 211.765 96.8209 214.756C96.8209 215.4 96.2989 215.922 95.655 215.922C95.0111 215.922 94.4891 215.4 94.4891 214.756C94.4891 212.504 93.3694 210.221 91.8262 208.213C90.2949 206.22 88.4504 204.633 87.2465 203.799C86.7171 203.433 86.585 202.707 86.9515 202.177Z"
        fill="#252A38"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M65.6377 198.717C66.2691 198.591 66.8833 199 67.0096 199.632C67.1358 200.263 66.7264 200.877 66.095 201.004C58.5336 202.516 51.7333 202.667 46.8227 202.44C44.3661 202.327 42.3784 202.119 41.0001 201.938C40.3109 201.848 39.7736 201.764 39.4059 201.703C39.2221 201.672 39.0806 201.647 38.9836 201.629C38.9351 201.62 38.8978 201.613 38.8718 201.608L38.8415 201.602L38.8328 201.6L38.8301 201.6C38.8298 201.6 38.8285 201.599 39.0571 200.456"
        fill="#252A38"
      />
      <path
        d="M155.959 103.069L160.351 51.48C160.479 49.976 161.802 48.8606 163.306 48.9887C164.81 49.1167 165.925 50.4397 165.797 51.9437L164.401 68.3402C164.174 71.0138 166.157 73.3658 168.83 73.5935L175.487 74.1602C178.16 74.3879 180.143 76.7399 179.916 79.4135L177.744 104.924C177.516 107.597 175.164 109.58 172.49 109.353L160.388 108.322C157.714 108.094 155.731 105.742 155.959 103.069Z"
        fill="#E5986D"
      />
      <path
        d="M148.708 106.963C149.049 102.952 152.577 99.9779 156.588 100.319L174.742 101.865C178.752 102.207 181.727 105.735 181.385 109.745L173.771 197.242C173.411 201.376 169.95 204.549 165.801 204.549L140.042 204.548L148.708 106.963Z"
        fill="#6C64D9"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M160.623 79.4372C159.467 79.7631 158.114 80.3845 157.132 80.8914C156.536 81.1993 155.811 80.9497 155.512 80.3339C155.214 79.718 155.456 78.9692 156.052 78.6613C157.083 78.1292 158.602 77.4222 159.987 77.0319C160.668 76.8397 161.412 76.6962 162.085 76.7391C162.748 76.7813 163.648 77.0383 164.1 77.9722C164.497 78.7914 164.643 79.6171 164.488 80.4351C164.337 81.2321 163.925 81.8797 163.461 82.4071C163.001 82.9296 162.432 83.3976 161.872 83.8264C161.616 84.0222 161.349 84.2196 161.085 84.4144C161.057 84.4355 161.028 84.4567 161 84.4777C160.705 84.6956 160.413 84.9125 160.123 85.1371C159.589 85.5503 158.833 85.4386 158.433 84.8878C158.033 84.337 158.141 83.5556 158.674 83.1424C158.988 82.8996 159.299 82.6685 159.594 82.4504C159.622 82.4295 159.651 82.4086 159.679 82.3879C159.945 82.1909 160.195 82.006 160.434 81.8234C160.968 81.4146 161.38 81.0645 161.674 80.7299C161.965 80.4002 162.081 80.1517 162.119 79.9553C162.148 79.8008 162.148 79.5769 162.006 79.234C161.987 79.2316 161.964 79.2295 161.937 79.2277C161.655 79.2098 161.211 79.2713 160.623 79.4372ZM162.096 79.2523C162.096 79.2525 162.092 79.2513 162.085 79.2481C162.093 79.2504 162.096 79.252 162.096 79.2523Z"
        fill="#252A38"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M154.371 99.3592C154.427 98.612 155.025 98.0568 155.705 98.119L170.543 99.4766C171.223 99.5389 171.729 100.195 171.672 100.942C171.615 101.69 171.018 102.245 170.337 102.182L155.5 100.825C154.82 100.763 154.314 100.106 154.371 99.3592Z"
        fill="#252A38"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M146.133 122.286C146.797 122.286 147.38 122.831 147.336 123.5C146.836 131 147.032 129.852 143.988 140.295C143.8 140.938 143.132 141.306 142.494 141.117C141.856 140.928 141.492 140.253 141.679 139.61C144.651 129.414 144.336 131 144.929 123.5C144.929 122.829 145.468 122.286 146.133 122.286Z"
        fill="#252A38"
      />
    </svg>
  );
};

export default NoRowsSvg;
